var jlLoader = {

  show:function(text){
    document.getElementById("jlPageLoader").classList.add("show");
    var loaderText = document.getElementsByClassName("jlPageLoaderText");
    for(let i = 0;i<loaderText.length;i++){
      loaderText[i].innerHTML = text;
    }



  },
  hide:function(){
    document.getElementById("jlPageLoader").classList.remove("show");
    var loaderText = document.getElementsByClassName("jlPageLoaderText");
    for(let i = 0;i<loaderText.length;i++){
      loaderText[i].innerHTML = "";
    }
  }
}

window.addEventListener("pageshow",function(){
  jlLoader.hide();
});
